export default "__VITE_ASSET__T6FK1MZ0__"